import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './button.scss';

const Button = ({ label = 'Submit', className, disabled, callbackOnClick }) => (
     <div className={css.component}>
        <input className={`${className}`} type="button" value={label} onClick={callbackOnClick} disabled={disabled} />
    </div>
);

Button.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    callbackOnClick: PropTypes.func
};

export default Button;
